<template>
  <div class="v-price-range">
    <v-card class="v-price-range__menu-content">
      <v-card-text>
        <div
          :class="{
            'v-price-range__pickers': true
          }"
        >
          <v-card-text>
            <div>
              <v-row>
                <v-col cols="6">
                  <v-currency-field
                    v-model="range[0]"
                    :error-messages="form.errors[0]"
                    :label="lang.historic.filters.price_range.min"
                    filled
                  />
                </v-col>
                <v-col cols="6">
                  <v-currency-field
                    v-model="range[1]"
                    :error-messages="form.errors[1]"
                    :label="lang.historic.filters.price_range.max"
                    filled
                  />
                </v-col>
              </v-row>
            </div>
          </v-card-text>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import appdata from '@/mixins/appdata'

export default {
  name: 'v-pricerange',
  mixins: [ appdata ],
  props: {
    value: {
      type: Array,
      default: () => {
        return [ 0.00, 0.00 ]
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      range: [ ...this.value ],
      form: {
        old: [ ...this.value ],
        timeout: null,
        errors: [ null, null ]
      }
    }
  },
  watch: {
    range: {
      deep: true,
      handler (newVal) {
        let oldVal = this.form.old
        clearTimeout(this.form.timeout)
        this.form.timeout = setTimeout(function () {
          if (newVal[0] !== oldVal[0] || newVal[1] !== oldVal[1]) {
            if (this.validate([ ...newVal ])) {
              this.form.errors = [ null, null ]
              this.$emit('input', this.range)
            }
            this.form.old = [ ...newVal ]
          }
          clearTimeout(this.form.timeout)
        }.bind(this), 500)
      }
    },
    value: {
      deep: true,
      handler (newVal) {
        if (newVal[0] !== this.range[0] || newVal[1] !== this.range[1]) this.range = [ ...this.value ]
      }
    }
  },
  methods: {
    validate (range) {
      let min = Number.parseFloat(range[0]) || null
      let max = Number.parseFloat(range[1]) || null
      if (min !== null && min < 0) {
        this.form.errors[0] = this.lang.historic.filters.price_range.errors.negative_min
        return false
      }
      if (max !== null && max < 0) {
        this.form.errors[1] = this.lang.historic.filters.price_range.errors.negative_max
        return false
      }
      if (min !== null && max !== null && (Math.round(min * 100) / 100) > (Math.round(max * 100) / 100)) {
        this.form.errors[0] = this.lang.historic.filters.price_range.errors.invalid_min
        this.form.errors[1] = this.lang.historic.filters.price_range.errors.invalid_max
        return false
      }
      return true
    }
  }
}
</script>
